import React, { useEffect, useState } from "react";
import { useSetState } from "Helpers/Hooks";
import Translator from "Languages/Utility/Translator";
import Grid from "@material-ui/core/Grid";
import Input from "Components/Input/Input";
import phoneMask from "Components/Input/components/phoneMask";
import { useDispatch, useSelector } from "react-redux";
import MuiButton from "Components/MuiButton/MuiButton";
import * as R from "ramda";
import { read } from "Helpers/LocalStorage";
import { postSettingMali } from "Stores/actions";
import showNotify from "Helpers/Notify";
import ImageUpload from "Components/ImageUpload/ImageUpload";
import BackDropLoading from "Components/BackDropLoading/BackDropLoading";
import { useTranslation } from "react-i18next";
import * as Icons from "react-bootstrap-icons";
import MuiPaper from "Components/MuiPaper/MuiPaper";

function FormMali(props) {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { settingMaliData } = useSelector((state) => ({
    settingMaliData: state.setting.settingMaliData,
  }));
  const [loading, setLoading] = useState(false);
  const [formValid, setFormValid] = useState({});
  const [logoUrl, setLogoUrl] = useState("");
  const [waterMarkUrl, setWaterMarkUrl] = useState("");
  const [controls, setControls] = useSetState({
    glassCalc: {
      type: "text",
      value: "",
      endIcon: "m2",
      validation: {
        required: true,
      },
      col: {
        md: 3,
        sm: 6,
        xs: 12,
      },
    },
    netCalc: {
      type: "text",
      value: "",
      endIcon: "m2",
      validation: {
        required: true,
      },
      col: {
        md: 3,
        sm: 6,
        xs: 12,
      },
    },
    costArc: {
      type: "text",
      value: "",
      endIcon: "moneyUnit",
      validation: {
        required: true,
      },
      col: {
        md: 3,
        sm: 6,
        xs: 12,
      },
    },
    costAngle: {
      type: "text",
      value: "",
      endIcon: "moneyUnit",
      validation: {
        required: true,
      },
      col: {
        md: 3,
        sm: 6,
        xs: 12,
      },
    },
    preInvoiceTitle: {
      type: "text",
      value: "",
      validation: {
        required: true,
      },
      col: {
        md: 6,
        sm: 6,
        xs: 12,
      },
    },
    invoiceTitle: {
      type: "text",
      value: "",
      validation: {
        required: true,
      },
      col: {
        md: 6,
        sm: 6,
        xs: 12,
      },
    },
    header: {
      type: "text",
      value: "",
      validation: {
        required: true,
      },
      col: {
        md: 6,
        sm: 6,
        xs: 12,
      },
    },
    headerSlogan: {
      type: "text",
      value: "",
      validation: {
        required: true,
      },
      col: {
        md: 6,
        sm: 6,
        xs: 12,
      },
    },
    tell: {
      type: "text",
      value: "",
      validation: null,
      col: {
        md: 4,
        sm: 4,
        xs: 12,
      },
    },
    email: {
      type: "text",
      value: "",
      validation: null,
      col: {
        md: 4,
        sm: 4,
        xs: 12,
      },
    },
    web: {
      type: "text",
      value: "",
      validation: null,
      col: {
        md: 4,
        sm: 4,
        xs: 12,
      },
    },
    address: {
      type: "text",
      value: "",
      validation: null,
      multiline: true,
      col: {
        md: 6,
        sm: 6,
        xs: 12,
      },
    },
    footer: {
      type: "text",
      value: "",
      validation: null,
      multiline: true,
      col: {
        md: 6,
        sm: 6,
        xs: 12,
      },
    },
  });

  const setValue = (name, value, validation) => {
    setControls({ [name]: { value: value } });
    setFormValid((prev) => ({ ...prev, [name]: validation }));
  };

  useEffect(() => {
    if (settingMaliData) {
      setControls({ glassCalc: { value: settingMaliData.GlassCalc } });
      setControls({ netCalc: { value: settingMaliData.NetCalc } });
      setControls({ costArc: { value: settingMaliData.CostArc } });
      setControls({ costAngle: { value: settingMaliData.CostAngle } });
      setControls({ header: { value: settingMaliData.Header } });
      setControls({ headerSlogan: { value: settingMaliData.HeaderSlogan } });
      setControls({
        preInvoiceTitle: { value: settingMaliData.ProformaInvoice },
      });
      setControls({ invoiceTitle: { value: settingMaliData.Invoice } });
      setControls({ tell: { value: settingMaliData.Tell } });
      setControls({ email: { value: settingMaliData.Email } });
      setControls({ web: { value: settingMaliData.Web } });
      setControls({ address: { value: settingMaliData.Address } });
      setControls({ footer: { value: settingMaliData.Footer } });
      const validation_data = {};
      Object.keys(controls)
        .filter((key) => controls[key].type !== "checkbox")
        .map((key) => {
          validation_data[key] =
            controls[key].value !== null || controls[key].value !== ""
              ? true
              : false;
        });
      setFormValid(validation_data);
    }
  }, [settingMaliData]);

  const onFinish = async (e) => {
    e.preventDefault();
    if (
      (!R.isEmpty(formValid) &&
        Object.values(formValid).every((item) => item === true)) ||
      R.isEmpty(formValid)
    ) {
      const {
        glassCalc,
        netCalc,
        costArc,
        costAngle,
        header,
        headerSlogan,
        preInvoiceTitle,
        invoiceTitle,
        tell,
        email,
        web,
        address,
        footer,
      } = controls;
      try {
        setLoading(true);
        const data = {
          KeyGroup: read("groupKey"),
          KeyUser: read("userKey"),
          GlassCalc: +glassCalc.value,
          NetCalc: +netCalc.value,
          CostArc: +costArc.value,
          CostAngle: +costAngle.value,
          Address: address.value,
          Email: email.value,
          Footer: footer.value,
          Header: header.value,
          HeaderSlogan: headerSlogan.value,
          ProformaInvoice: preInvoiceTitle.value,
          Invoice: invoiceTitle.value,
          Logo: logoUrl,
          WaterMarkImage: waterMarkUrl,
          Tell: tell.value,
          Web: web.value,
        };
        await dispatch(postSettingMali(data));
        setLoading(false);
      } catch (e) {
        setLoading(false);
        showNotify({
          text: t("correctFormDataRequired"),
          customClass: "error",
        });
      }
    } else {
      showNotify({
        text: t("correctFormDataRequired"),
        customClass: "error",
      });
    }
  };

  return (
    <>
      <div className="d-flex flex-row mb-3">
        <ImageUpload
          object={"Logo"}
          box_title={"CheckLogo"}
          button_label={"uploadLogo"}
          image={settingMaliData?.Logo}
          onSetImage={(url) => setLogoUrl(url)}
          maxSize={500000}
        />
        <ImageUpload
          object={"WaterMark"}
          box_title={"WaterMark"}
          button_label={"uploadWaterMark"}
          image={settingMaliData?.WaterMarkImage}
          onSetImage={(url) => setWaterMarkUrl(url)}
          maxSize={700000}
        />
      </div>
      <MuiPaper>
        <Grid container spacing={2}>
          {Object.keys(controls).map((key, index) => {
            return (
              <Grid
                item
                md={controls[key].col.md}
                sm={controls[key].col.sm}
                xs={controls[key].col.xs}
                key={key + index}
              >
                {controls[key].type === "text" && (
                  <Input
                    loading={props.loading}
                    setValue={setValue.bind(this)}
                    name={key}
                    validation={controls[key].validation}
                    label={<Translator id={key} />}
                    value={controls[key].value}
                    type="text"
                    multiline={controls[key].multiline}
                    endIcon={
                      controls[key].endIcon && (
                        <Translator id={controls[key].endIcon} />
                      )
                    }

                    disabled={loading}
                  />
                )}
                {controls[key].type === "phone" && (
                  <Grid direction="ltr">
                  <Input
                    setValue={setValue.bind(this)}
                    name={key}
                    validation={controls[key].validation}
                    label={<Translator id={key} />}
                    type="text"
                    className={"phone"}
                    defaultValue={controls[key].value}
                    // inputComponent={phoneMask}
                    disabled={loading}
                  />
                  </Grid>
                )}
              </Grid>
            );
          })}
          <Grid item xs={12} className="d-flex justify-content-end my-4">
            <MuiButton
              loading={loading}
              color="primary"
              title={<Translator id="zakhirTanzimatMali" />}
              innerIcon={<Icons.Floppy />}
              onClick={onFinish}
              fullwidthOnSm
            />
          </Grid>
        </Grid>
      </MuiPaper>
    </>
  );
}

export default FormMali;
